export const enum EnumInstallTypesErrorCode
{
	SUCCESS = 0,

	NOT_EXISTS = 1,
	DEPRECATED = 2,

	SKIP = 3,
}
